import type { BoardScene } from "@/lib/canvas/board-schema";

function boardEvidenceKey(scene: BoardScene): string {
  const evidence = {
    ...scene,
    // Loading legacy boards generates fresh Konva identities each time. Those
    // identities are not an edit; player_id and every other field still are.
    tokens: scene.tokens.map(({ id: _id, ...token }) => token),
    shapes: scene.shapes.map(({ id: _id, ...shape }) => shape),
  };
  return JSON.stringify(evidence, (_key: string, value: unknown) => {
    // Property insertion order is not evidence. Array order is: it controls
    // the stacking of tokens/shapes and the path of a freehand stroke.
    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      return Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)));
    }
    return value;
  });
}

/** Compare validated in-memory scenes without treating generated IDs as edits. */
export function hasBoardEvidenceChanges(current: BoardScene, saved: BoardScene): boolean {
  return boardEvidenceKey(current) !== boardEvidenceKey(saved);
}
